// startup
// Load entry module and return exports
__webpack_require__("./node_modules/error-overlay-webpack-plugin/dist/entries/basic.mjs");
// This entry module is referenced by other modules so it can't be inlined
var __webpack_exports__ = __webpack_require__("./wp-content/themes/socialbrothers/src/scripts/main.ts");
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
